import { useDispatch } from 'react-redux'
import { openScreen, updateScreenParams } from '@slices/uiSlice'

// Tournament screen navigation, kept out of components. Detail navigation
// pushes a SECOND entry onto the existing generic sidebar screen stack
// (uiSlice `sidebar.history`) — the same mechanism Menu.jsx already uses for
// MY_BETS/FREEBETS/etc, just nested one level deeper. The full tournament row
// (already fetched by the list) is carried in `params` since there is no
// "get tournament by id" query — only list/history.
export const useTournamentNavigation = () => {
  const dispatch = useDispatch()

  const onViewTournament = (tournament, origin) => {
    dispatch(
      openScreen({
        key: 'tournamentDetail',
        title: tournament?.name ?? 'Tournament',
        screen: 'TOURNAMENT_DETAIL',
        params: { tournament, origin },
      })
    )
  }

  // Persists the Current/History tab choice onto the TOURNAMENTS stack entry
  // so it survives a drill-down + back (that entry stays in the array; only
  // the component instance reading it remounts).
  const onSelectTournamentsTab = (tabKey) => {
    dispatch(updateScreenParams({ activeTab: tabKey }))
  }

  return { onViewTournament, onSelectTournamentsTab }
}
